/* eslint-disable */
import {
  Container,
  createStyles,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Theme,
  withStyles,
} from "@material-ui/core";
import { show } from "redux-modal";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { connectModal } from "redux-modal";
import CancelIcon from "@material-ui/icons/Cancel";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import {
  getDirectoryDocuments,
  addDirectory,
  addDocumentFund,
  getFundEnvelopes,
  deleteDirectory,
  deleteDocument,
  getPartEnvelopes,
  deleteEnvelopePart,
  getDocumentPart,
  deleteDocumentPart,
} from "../../utils/store/actions/document.actions";
import FolderIcon from "@material-ui/icons/Folder";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import ModalAddDocumentInDirectory from "./Modal.AddDocumentInDirectory";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import { TreeItem } from "@material-ui/lab";
import { baseUri } from "../../utils/uri";
import axios from "axios";
import { divide } from "lodash";

const styles = (theme: Theme) =>
  createStyles({
    dropzone: {
      minHeight: "150px",
      marginBottom: "20px",
    },
    previewChip: {
      width: "100px",
    },
  });

class ModalManageDocumentPart extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      node: "root",
    };
  }
  queryString = window.location.search;
  urlParams = new URLSearchParams(this.queryString);
  partId = this.urlParams.get("partId");
  fundPersonId = this.urlParams.get("id");

  componentDidMount() {
    this.props.getPartEnvelopes(this.fundPersonId, this.partId);
  }
  async handleTreeItem(id: any, index: any) {
    if (index === "root") {
      this.setState({ node: index, parentDirectoryId: "" });
    } else {
      await this.props.getDocumentPart(
        this.fundPersonId,
        this.partId,
        id,
      );
      this.setState({ node: index + 2, parentDirectoryId: id });
    }
  }
  handleDeleteDirectory(id: any) {
    this.props
      .deleteEnvelopePart(this.fundPersonId, this.partId, id,)
      .then(() => {
        this.props.getPartEnvelopes(this.fundPersonId, this.partId);
      });
  }
  handleDeleteDocument(id: any, directoryId: any) {
    this.props
      .deleteDocumentPart(
        this.fundPersonId,
        this.partId,
        directoryId,
        id
      )
      .then(() => {
        if (this.state.open === "") {
          this.props.getPartEnvelopes(this.fundPersonId, this.partId);
        } else {
          this.props.getDocumentPart(
            this.fundPersonId,
            this.partId,
            directoryId,
          );
        }
      });
  }
  handlePreview(file: any) {
    axios({
      method: "get",
      url: `${baseUri}/service-document/v1/persons/${this.props.fundPerson}/parts/${this.props.partId}/${this.state.open}/document/${file.id}`,
      responseType: "blob",
    }).then((res: any) => {
      this.setState({
        file: URL.createObjectURL(res.data),
        blob: res.data,
        fileName: file.name,
        open: true,
      });
      var element = document.createElement("a");
      element.href = this.state.file;
      element.setAttribute("download", `${file.name}`);
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    });
  }
  TreeRender = (data: any, index: any) => {
    return (
      <TreeItem
        onClick={() => this.handleTreeItem(data.id, index)}
        key={data.id}
        icon={<FolderIcon style={{ color: "#7C88B1" }} />}
        nodeId={`${index + 2}`}
        label={data.name}
        style={{ padding: "12px" }}
      />
    );
  };
  render() {
    const { show, handleHide, t, classes } = this.props;
    const closeBtn = (
      <IconButton className="close" onClick={handleHide}>
        <CancelIcon />
      </IconButton>
    );
    return (
      <div>
        <ModalAddDocumentInDirectory />
        <Modal
          isOpen={show}
          toggle={handleHide}
          backdrop={true}
          style={{
            backgroundColor: "#f5f6ff",
            top: "20%",
            maxWidth: "fit-content",
          }}
        >
          <ModalHeader
            toggle={handleHide}
            close={closeBtn}
            style={{
              backgroundColor: "#f5f6ff",
              fontWeight: "bolder",
            }}
          >
            {t("ADD_DOCUMENT_OR_FOLDER")}
          </ModalHeader>
          <ModalBody
            style={{
              backgroundColor: "#f5f6ff",
            }}
          >
            <Container style={{ padding: 20 }}>
              <List
                style={{ maxHeight: 1000, overflow: "auto" }}
                className={classes.root}
              >
                {this.state.node === "root" ? (
                  <>
                    {this.props.Documents?.partDocuments.length !== 0 ? (
                      this.props.Documents?.partDocuments?.map(
                        (directory: any, index: any) => {
                          return (
                            !directory.isDeleted && (
                              <>
                                <ListItem
                                  className={classes.listItem}
                                  key={directory.id}
                                  style={{
                                    borderBottom: "2px solid",
                                    borderColor: "#EAEDF7",
                                  }}
                                  onClick={() => {
                                    this.handleTreeItem(
                                      directory.id,
                                      index
                                    ).then(() =>
                                      this.setState({
                                        open:
                                          this.state.open === directory.id
                                            ? ""
                                            : directory.id,
                                      })
                                    );
                                  }}
                                >
                                  <ListItemAvatar>
                                    {this.state.open === directory.id ? (
                                      <FolderOpenIcon
                                        style={{
                                          height: "50px",
                                          width: "50px",
                                          color: "#AE0064",
                                        }}
                                      />
                                    ) : (
                                      <FolderIcon
                                        style={{
                                          height: "50px",
                                          width: "50px",
                                          color: "#AE0064",
                                        }}
                                      />
                                    )}
                                  </ListItemAvatar>

                                  <ListItemText
                                    id={directory.id}
                                    primary={this.props.t(directory.name)}
                                  />
                                    <ListItemSecondaryAction>
                                      <DeleteOutlinedIcon
                                        style={{ color: "#97A0C3" }}
                                        onClick={() => {
                                          this.handleDeleteDirectory(
                                            directory.id
                                          );
                                        }}
                                      />
                                    </ListItemSecondaryAction>
                                </ListItem>
                              </>
                            )
                          );
                        }
                      )
                    ) : (
                      <div></div>
                    )}
                  </>
                ) : (
                  <>
                    {this.props.Documents?.partDocuments &&
                    this.props.Documents?.partDocuments?.length !== 0 ? (
                      this.props.Documents?.partDocuments.map(
                        (envelope: any, index: any) => {
                          return (
                            !envelope.isDeleted && (
                              <>
                                <ListItem
                                  className={classes.listItem}
                                  key={envelope.id}
                                  style={{
                                    borderBottom: "2px solid",
                                    borderColor: "#EAEDF7",
                                  }}
                                  onClick={() => {
                                    this.handleTreeItem(
                                      envelope.id,
                                      index
                                    ).then(() =>
                                      this.setState({
                                        open:
                                          this.state.open === envelope.id
                                            ? ""
                                            : envelope.id,
                                      })
                                    );
                                  }}
                                >
                                  <ListItemAvatar>
                                    {this.state.open === envelope.id ? (
                                      <FolderOpenIcon
                                        style={{
                                          height: "50px",
                                          width: "50px",
                                          color: "#AE0064",
                                        }}
                                      />
                                    ) : (
                                      <FolderIcon
                                        style={{
                                          height: "50px",
                                          width: "50px",
                                          color: "#AE0064",
                                        }}
                                      />
                                    )}
                                  </ListItemAvatar>
                                  <ListItemText
                                    id={envelope.id}
                                    primary={this.props.t(envelope.name)}
                                  />
                                    <ListItemSecondaryAction>
                                      <DeleteOutlinedIcon
                                        style={{ color: "#97A0C3" }}
                                        onClick={() => {
                                          this.handleDeleteDirectory(
                                            envelope.id
                                          );
                                        }}
                                      />
                                    </ListItemSecondaryAction>
                                </ListItem>
                                {this.props.Documents.partDocument &&
                                  this.props.Documents.partDocument
                                    .documents &&
                                  this.state.open === envelope.id &&
                                  this.props.Documents.partDocument.documents.map(
                                    (doc: any) => (
                                      <>
                                        <ListItem
                                          className={classes.listItem}
                                          key={doc.id}
                                          style={{
                                            marginLeft: "3vh",
                                            borderBottom: "2px solid",
                                            borderColor: "#EAEDF7",
                                          }}
                                          onClick={() => {
                                            this.handlePreview(doc);
                                          }}
                                        >
                                          <ListItemAvatar>
                                            <InsertDriveFileIcon
                                              style={{
                                                height: "50px",
                                                width: "50px",
                                                color: "#7C88B1",
                                              }}
                                            />
                                          </ListItemAvatar>

                                          <ListItemText
                                            id={doc.id}
                                            primary={doc.name}
                                          />

                                          <ListItemSecondaryAction>
                                            <DeleteOutlinedIcon
                                              style={{
                                                color: "#97A0C3",
                                              }}
                                              onClick={() => {
                                                this.handleDeleteDocument(
                                                  doc.id,
                                                  envelope.id
                                                );
                                              }}
                                            />
                                          </ListItemSecondaryAction>
                                        </ListItem>
                                      </>
                                    )
                                  )}
                              </>
                            )
                          );
                        }
                      )
                    ) : (
                      <div></div>
                    )}
                  </>
                )}
              </List>
              <Container style={{ padding: "20px", display: "flex" }}>
                {this.state.open ? (
                  <Button
                    style={{ textTransform: "none", width: "100%" }}
                    onClick={(e: any) =>
                      this.props.showModal("add_doc_directory", {
                        name: "add_doc_directory",
                        history,
                        actionDone: "DOCUMENT_PART",
                        parentDirectoryId: this.state.open,
                      })
                    }
                  >
                    <AddCircleOutlineIcon
                      style={{
                        color: "#ae0064",
                        marginRight: "20px",
                      }}
                    />
                    {t("ADD_DOCUMENT")}
                  </Button>
                ) : (
                  <Button
                    style={{ textTransform: "none", width: "100%" }}
                    onClick={(e: any) =>
                      this.props.showModal("add_doc_directory", {
                        name: "add_doc_directory",
                        history,
                        actionDone: "DIRECTORY_PART",
                        parentDirectoryId: this.fundPersonId,
                        partId: this.partId,
                      })
                    }
                  >
                    <AddCircleOutlineIcon
                      style={{
                        color: "#ae0064",
                        marginRight: "20px",
                      }}
                    />
                    {t("ADD_DIRECTORY")}
                  </Button>
                )}
              </Container>
            </Container>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});
const mapDispatchToProps = {
  showModal: show,
  deleteDocument,
  getPartEnvelopes,
  deleteEnvelopePart,
  getDocumentPart,
  deleteDocumentPart,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withTranslation()(
    withStyles(styles)(
      connectModal({ name: "manage_document_part" })(ModalManageDocumentPart)
    )
  )
);
